"use client";

import React, { useState, useRef, useEffect } from "react";
import { getStrapiURL } from "@/helper/image-helper";

interface TabContent {
    ImportantTabs: Array<{
        btnName: string;
        image: {
            url: string;
        };
        Title: string;
        linkText: string;      
        icon: {
            url: string;
        };
        textItem: Array<{
            text: string;
        }> 
    }> 
}

const ContentTabs: React.FC<TabContent> = ({ ImportantTabs }) => {
    const [activeTab, setActiveTab] = useState<number>(1);
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRefs = useRef<Map<number, HTMLDivElement>>(new Map());



    useEffect(() => {

        const activeContent = contentRefs.current.get(activeTab);
        if (containerRef.current && activeContent) {
            containerRef.current.style.height = `${activeContent.offsetHeight}px`;
        }
    }, [activeTab]);

    const handleTabClick = (id: number) => {
        setActiveTab(id);
    };

    return (
        <div className="w-full">
            {/* Tabs */}
            <div className="flex justify-start gap-4 p-4 rounded-[48px] bg-gray-50 mb-[40px] max-[767px]:p-[8px] max-[767px]:mb-[16px] max-[576px]:gap-[8px] max-[576px]:justify-between">
                {ImportantTabs.map((item, index) => (
                    <button
                        key={index}
                        onClick={() => handleTabClick(index + 1)}
                        className={`uppercase inline-flex items-center ${
                            activeTab === index + 1
                                ? "text-violet-500 font-bold border-white shadow-[0_4px_16px_0_#00000026]"
                                : "text-violet-200 border-blue-violet-50 font-normal border-2"
                        } py-3.5 px-12 max-[768px]:py-[12px] max-[768px]:px-[21px] max-[576px]:px-[20px] max-[768px]:text-[12px] max-[768px]:leading-[1] rounded-[32px] bg-white leading-[143%]`}
                    >
                    {item.btnName}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div ref={containerRef} className="relative transition-height duration-500">
                {ImportantTabs.map((item, index) => (
                    <div
                    key={index}
                    ref={(el) => {
                        if (el) {
                        contentRefs.current.set(index + 1, el);
                        } else {
                        contentRefs.current.delete(index + 1);
                        }
                    }}
                    className={`absolute flex justify-between gap-2 left-0 top-0 w-full transition-opacity ease-in-out max-[992px]:flex-wrap ${
                        activeTab === index + 1
                        ? "opacity-100 visible duration-500"
                        : "opacity-0 invisible duration-0"
                    }`}
                    >
                    {/* Левый блок: заголовок + текст */}
                    <div className="w-full max-w-[650px] max-[1300px]:w-1/2 max-[992px]:max-w-full max-[992px]:w-full max-[992px]:gap-[16px] max-[992px]:order-2">
                        <h3 className="max-w-[552px] font-bold text-black-50 text-[20px] leadind-[140%] mb-[24px] max-[767px]:text-[16px] max-[767px]:leading-[100%] max-[767px]:mb-[16px]">
                        {item.Title}
                        </h3>
                        <ul className="list-disc pl-6 text-gray-900 text-[20px] leading-[140%] max-[767px]:text-[14px]">
                        {item.textItem.map((text, i) => (
                            <li key={i}>{text.text}</li>
                        ))}
                        </ul>
                        {item.linkText && (
                        <p className="mt-4 text-violet-500 underline">{item.linkText}</p>
                        )}
                    </div>

                    {/* Правый блок: изображение */}
                    <div className="w-[552px] h-[374px] flex justify-center max-[1200px]:w-1/2 max-[1200px]:h-full max-[992px]:w-full">
                        <img
                        src={getStrapiURL(item.image.url)}
                        alt={item.btnName}
                        className="w-full h-full object-cover rounded-3xl max-[576px]:rounded-[10px]"
                        />
                    </div>
                    </div>
                ))}
                </div>

        </div>
    );
};

export default ContentTabs;
